import './PracticeRelations.css';
import React, { useState } from 'react';
import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Col,
    Row,
    UncontrolledDropdown,
    DropdownMenu,
    DropdownItem,
    DropdownToggle,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons';
import { actions } from '../../context';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import EditPracticeRelationsModal from '../Modals/EditPracticeRelationsModal';
import DeletePracticeRelationsModal from '../Modals/DeletePracticeRelationsModal';

let flagStyles = { fontSize: '14px', whiteSpace: 'nowrap' };

// todo: do a better refactor
//Renders a list of partners associated with the selected practice
let PracticeRelationsModal = () => {
    const dispatch = useDispatch();
    const practiceId = useSelector(
        (state) => state.practice.practiceRelationsModalWorkingPractice?.id
    );
    const isRelationsModalOpen = useSelector(
        (state) => state.toggle.isRelationsModalOpen
    );
    // TODO: do proper diffing
    const currentRelations = useSelector(
        (state) => state.relations.relations,
        shallowEqual
    );

    const [isEditRelationsModalOpen, setIsEditRelationsModalOpen] =
        useState(false);
    const [isDeleteRelationsModalOpen, setIsDeleteRelationsModalOpen] =
        useState(false);
    const [actionRelation, setActionRelation] = useState();

    const addRelation = () => {
        setActionRelation();
        setIsEditRelationsModalOpen(true);
    };

    const editRelation = (relation) => {
        setActionRelation(relation);
        setIsEditRelationsModalOpen(true);
    };

    const deleteRelation = (relation) => {
        setActionRelation(relation);
        setIsDeleteRelationsModalOpen(true);
    };

    const displayPartnerOfferingList = currentRelations.map((item, index) => {
        return (
            <tr
                key={`${index}-${item?.id}`}
                id={item?.id}
                className="no-border opaque bg bg-light text-secondary row my-2">
                <td className="table-label col-4">
                    {item.name}
                    <span className="d-block" style={{ fontSize: '14px' }}>
                        {item?.partnerName}
                    </span>
                </td>
                <td className="table-value col-7">
                    <span className="d-block text-truncate">
                        {item?.customPartnerId &&
                            `Partner Custom Id: ${item?.customPartnerId}`}
                    </span>
                    {item?.isConversionOffering && (
                        <span className="mr-3" style={flagStyles}>
                            <FontAwesomeIcon icon="check"></FontAwesomeIcon>{' '}
                            Conversion
                        </span>
                    )}
                    {item?.convertAttachments && (
                        <span className="mr-3" style={flagStyles}>
                            <FontAwesomeIcon icon="check"></FontAwesomeIcon>{' '}
                            Convert Attachments
                        </span>
                    )}
                    {item?.isDaylightOffering && (
                        <span style={flagStyles}>
                            <FontAwesomeIcon icon="check"></FontAwesomeIcon>{' '}
                            Daylight
                        </span>
                    )}
                </td>
                <td className="col-1 px-0">
                    <UncontrolledDropdown direction="left">
                        <DropdownToggle nav className="text-secondary">
                            <FontAwesomeIcon icon={faEllipsisV} size="lg" />
                        </DropdownToggle>
                        <DropdownMenu>
                            <DropdownItem
                                className=""
                                onClick={() =>
                                    isEditRelationsModalOpen ||
                                    editRelation(item)
                                }>
                                Edit
                            </DropdownItem>
                            <DropdownItem
                                className=""
                                onClick={() =>
                                    isDeleteRelationsModalOpen ||
                                    deleteRelation(item)
                                }>
                                Delete
                            </DropdownItem>
                        </DropdownMenu>
                    </UncontrolledDropdown>
                </td>
            </tr>
        );
    });

    const closeModal = () => {
        setIsEditRelationsModalOpen(false);
        setIsDeleteRelationsModalOpen(false);
        setActionRelation();
        dispatch(actions.toggle.toggleRelationsModalOpen(false));
    };

    const editToggle = () => {
        setIsEditRelationsModalOpen(false);
    };

    const deleteToggle = () => {
        setIsDeleteRelationsModalOpen(false);
    };

    return (
        <Modal
            isOpen={isRelationsModalOpen}
            toggle={() =>
                isRelationsModalOpen
                    ? closeModal()
                    : dispatch(
                          actions.toggle.toggleRelationsModalOpen(
                              !isRelationsModalOpen
                          )
                      )
            }
            className="modal-md text-light"
            centered={true}
            style={{ minWidth: '30vw' }}>
            <ModalHeader className="d-inline-block w-100 h-100">
                <Row>
                    <Col lg={8} sm="6" className="d-inline-block w-100 h-100">
                        <h4>Active Offerings</h4>
                    </Col>
                    <Col lg={4} sm="6" className="text-right">
                        <Button
                            id="iconButton"
                            onClick={() =>
                                isEditRelationsModalOpen ||
                                addRelation(practiceId)
                            }
                            color="primary">
                            <FontAwesomeIcon icon="edit" size="lg" />
                        </Button>
                    </Col>
                </Row>
            </ModalHeader>
            <ModalBody className="justify-content-center">
                {displayPartnerOfferingList.length > 0 ? (
                    <table style={{ tableLayout: 'fixed' }}>
                        <tbody>{displayPartnerOfferingList}</tbody>
                    </table>
                ) : (
                    <h6 className="text-center text-light">
                        No Offerings to Display
                    </h6>
                )}
                <EditPracticeRelationsModal
                    isOpen={isEditRelationsModalOpen}
                    toggle={editToggle}
                    practiceId={practiceId}
                    relation={actionRelation}
                />
                <DeletePracticeRelationsModal
                    isOpen={isDeleteRelationsModalOpen}
                    toggle={deleteToggle}
                    practiceId={practiceId}
                    relation={actionRelation}
                />
            </ModalBody>
            <ModalFooter>
                <Button
                    color="info"
                    className="float-right"
                    onClick={() => closeModal()}>
                    Close
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default PracticeRelationsModal;
